module.exports = __webpack_public_path__ + "static/media/service-block-2@4x.a6510c5f.jpg";